import PrivacyPolicyStatusViewModel from './PrivacyPolicyStatusViewModel'

export default class PrivacyPolicyStatusesViewModel {
    constructor(data) {
        this.servicePolicy = data.servicePolicy ? new PrivacyPolicyStatusViewModel(data.servicePolicy) : null
        this.specialContract = data.specialContract ? new PrivacyPolicyStatusViewModel(data.specialContract) : null
    }
}